module.exports = __webpack_public_path__ + "img/network_device-dashboard.165c2924.svg";